import React from 'react';
import SectionTitle from '../SectionTitle/SectionTitle';
import { Link } from 'react-router-dom';
import './WhyChooseEnhanced.css';

const WhyChooseEnhanced = () => {
    
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const benefits = [
        {
            icon: 'fa-lightbulb',
            headline: "Advanced Therapies Available Through Florida's Progressive Legislation",
            content: "Access cutting-edge Wharton's Jelly MSC therapies and advanced cellular treatments through Florida's unique regulatory environment. Receive treatments that aren't widely available in other US states, right here domestically.",
            points: []
        },
        {
            icon: 'fa-user-doctor',
            headline: "We Bring World-Class Care Directly to You",
            content: "Our unique concierge model brings Dr. Pereira's expertise to premium facilities throughout Florida. No need to travel to distant clinics - we optimize treatment locations for your convenience.",
            points: [
                "Strategic partnerships with state-of-the-art Florida facilities",
                "Treatment locations chosen for your optimal experience",
                "Coordinated care from consultation through recovery",
                "Personalized service throughout your journey"
            ]
        },
        {
            icon: 'fa-medal',
            headline: "25+ Years of Advanced Expertise You Can Trust",
            content: "Our expert team combines decades of interventional pain management experience with cutting-edge regenerative medicine training. FIPP and ABIPP certifications demonstrate the highest levels of procedural expertise.",
            points: [
                "Board-certified with advanced international credentials",
                "Thousands of successful procedures performed",
                "Trusted trainers of other physicians nationwide",
                "Multiple Florida hospital affiliations"
            ]
        },
        {
            icon: 'fa-syringe',
            headline: "Beyond Pain Management to Complete Regeneration",
            content: "We don't just manage symptoms - we address root causes through advanced cellular therapies, from joint regeneration to sexual wellness optimization.",
            points: [
                "Full spectrum regenerative medicine protocols",
                "Personalized treatment plans for your specific needs",
                "Integration of multiple therapeutic modalities",
                "Evidence-based approaches with proven outcomes"
            ]
        },
        {
            icon: 'fa-calendar-days',
            headline: "Premium Care Made Accessible",
            content: "Receive advanced treatments with domestic convenience, safety, and support. No complex travel arrangements - just exceptional care close to home.",
            points: [
                "Treatments available throughout Florida",
                "Same-day travel from most US locations",
                "Familiar healthcare environment and standards",
                "Easy follow-up and ongoing support"
            ]
        },
        {
            icon: 'fa-handshake',
            headline: "Dedicated to Your Success",
            content: "From initial consultation through recovery, our team provides personalized support and guidance every step of the way.",
            points: [
                "Thorough pre-treatment consultation and planning",
                "Coordinated treatment scheduling and logistics",
                "Comprehensive aftercare and monitoring",
                "Direct access to Dr. Pereira and clinical team"
            ]
        }
    ];

    return (
        <section className="why_choose_enhanced section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <SectionTitle 
                            title="Why Choose Amped Therapeutics?" 
                            subtitle="Experience advanced regenerative medicine through Florida's unique advantages and Dr. Pereira's world-class expertise" 
                        />
                    </div>
                </div>
                
                <div className="benefits-grid">
                    {benefits.map((benefit, index) => (
                        <div key={index} className="benefit-card">
                            <div className="benefit-icon">
                                <i className={`fas ${benefit.icon}`}></i>
                            </div>
                            <h3>{benefit.headline}</h3>
                            <p>{benefit.content}</p>
                            {benefit.points.length > 0 && (
                                <ul className="benefit-points">
                                    {benefit.points.map((point, idx) => (
                                        <li key={idx}>
                                            <i className="fas fa-check"></i>
                                            {point}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>

                <div className="summary-section">
                    <h3>The Amped Therapeutics Difference</h3>
                    <p>Combining Florida's regulatory advantages with Dr. Pereira's world-class expertise and our innovative concierge model, we deliver advanced regenerative medicine that's both accessible and exceptional. Experience the difference that 25+ years of clinical excellence and personalized care can make in your health journey.</p>
                </div>

                <div className="cta-section">
                    <h3>Ready to Experience the Amped Therapeutics Advantage?</h3>
                    <div className="cta-buttons">
                        <Link onClick={ClickHandler} to="/contact" className="primary-btn">
                            Schedule Your Consultation with Dr. Pereira
                        </Link>
                        <Link onClick={ClickHandler} to="/about" className="secondary-btn">
                            Learn More About Our Concierge Approach
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyChooseEnhanced;